var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"toast fb fb-cross-center fb-main-center",class:_vm.isShow ? 'fadein' : 'fadeout'},[_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }